import { render, staticRenderFns } from "./RegisterSmartbox.vue?vue&type=template&id=49e95512&scoped=true"
import script from "./RegisterSmartbox.vue?vue&type=script&lang=js"
export * from "./RegisterSmartbox.vue?vue&type=script&lang=js"
import style0 from "./RegisterSmartbox.vue?vue&type=style&index=0&id=49e95512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e95512",
  null
  
)

export default component.exports